export const measurementsEn = {
    "mm": "mm",
    "cm": "cm",
    "kg": "kg",
    "ton": "Ton",
    "unit": "unit",
    "units": "units",
    "ILS": "ILS",
    "zol": "zol",
}